var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactFormLineHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 330,
    height: 2,
    viewBox: "0 0 330 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M330 1L1.33216e-05 0.999986",
    stroke: "#BDC7C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactFormLineHorizontal);
export default __webpack_public_path__ + "static/media/contact-form-line-horizontal.629651b6cade5280659ae6787a129577.svg";
export { ForwardRef as ReactComponent };